<template>
	<div class="fondoModal">
		<div>
			<div style="max-width:1400px;">
				<div class="card">
					<div class="card-header">
						{{cliente}} - {{tipo}}
						<button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="cerrar">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="row">
						<div class="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-3">
							<table class="table table-condensed table-striped text-right">
								<thead>
									<tr>
										<th class="text-left">Mes</th>
										<th v-for="ano in anos" :key="ano.ano">{{ano.ano}}</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(val, mes) in new Array(12).fill(0)" :key="mes">
										<td class="text-left">
											{{getMes(mes)}}
										</td>
										<td v-for="ano in anos" :key="mes + '-' + ano.ano">
											{{ano.meses[mes] | currency('')}} €
										</td>
									</tr>
								</tbody>
								<tbody class="bg-dark text-white">
									<tr>
										<td class="text-left">TOTAL:</td>
										<td :colspan="anos.length"><b>{{importeTotal | currency('')}} €</b></td>
									</tr>
								</tbody>
							</table>
						</div>
						<div class="col-xs-12 col-sm-12 col-md-12 col-lg-8 col-xl-9">
							<chartjs-line
								:datalabel="'Facturación ' + cliente"
								:height="200"
								:labels="labelMeses"
								:datasets="chartData"
								>
							</chartjs-line>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	props: ['cliente', 'anos', 'tipo'],

	data () {
		return {}
	},

	computed: {
		labelMeses () {
			const m = []

			for (let i = 0; i < 12; i++) {
				m.push(this.getMes(i))
			}

			return m
		},
		chartData () {
			/**
			 *  label: ano,
				data: [],
				backgroundColor: color,
				borderColor: color,
				fill: false
			 */
			const sets = []
			for (let i in this.anos) {
				const color = this.getRandomColor()
				const set = {
					label: this.anos[i].ano,
					data: [],
					backgroundColor: color,
					borderColor: color,
					fill: false
				}
				for (let m = 0; m < this.anos[i].meses.length; m++) {
					set.data.push(this.anos[i].meses[m])
				}
				sets.push(set)
			}
			return sets
		},
		importeTotal () {
			let total = 0

			for (let i in this.anos) {
				total += this.anos[i].importe
			}

			return total
		}
	},

	methods: {
		getMes (mes) {
			const meses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']
			return meses[mes]
		},
		getRandomColor () {
			var letters = '0123456789ABCDEF'
			var color = '#'
			for (var i = 0; i < 6; i++) {
				color += letters[Math.floor(Math.random() * 16)]
			}
			return color
		},
		cerrar () {
			this.$emit('cerrar')
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/consultas-facturacion/vue/components/porClientes/verDetallesComparados.vue